import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const getAdditionalInformationDetailStripe = (payment) => [
  {
    label: 'Mensaje de fallo',
    value: payment?.failure_message,
  },
  {
    label: 'Es contracargo',
    value: payment?.is_chargeback ? 'Sí' : 'No',
  },
  {
    label: 'Es fraude',
    value: payment?.is_fraud ? 'Sí' : 'No',
  },
];

export const getIdentifiersStripe = (payment) => [
  {
    label: 'Código de fallo',
    value: payment?.failure_code,
  },
  {
    label: 'ID de la operación',
    value: payment?.charge_id,
  },
  {
    label: 'Stripe ID',
    value: payment?.id,
  },
  {
    label: 'ID de transacción',
    value: payment?.payment_intent_id,
  },
  {
    label: 'ID Pago',
    value: payment?.payment_order_uuid,
  },
];

export const getStripeTransactions = (orderDetails) => [
  {
    label: 'Fecha de transacción',
    value: convertToMexicoTime(orderDetails?.stripe_created_at),
  },
  {
    label: 'Fecha de creación',
    value: convertToMexicoTime(orderDetails?.created),
  },
  {
    label: 'Monto',
    value: <CurrencyFormatter amount={orderDetails?.total_amount} />,
  },
  {
    label: 'Tarjeta enmascarada',
    value: orderDetails?.masked_card,
  },
  {
    label: 'Estatus de pago',
    value: orderDetails?.status,
  },
  {
    label: 'Cuotas',
    value:
      orderDetails?.installments === 1 ? 'Contado' : `${orderDetails?.installments || '0'} meses`,
  },
  {
    label: 'Método de pago',
    value: orderDetails?.payment_method_type || 'No disponible',
  },
  {
    label: 'Comprobante de pago',
    value: orderDetails?.receipt_url ? 'Sí' : 'No',
  },
  {
    label: 'Código de autorización',
    value: orderDetails?.authorization_code || 'No disponible',
  },
];
